import moment from "moment";
import { Table, Badge, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { DateFormat } from "../../helper/constants";
import Loading from "../Loading";
import { CompanyPolicySchedule } from "../../interfaces/models/CompanyPolicySchedule";

interface Props {
  loading: boolean;
  hasCRUD: boolean;
  schedules: CompanyPolicySchedule[];
  handleOpenEditScheduleModal?: (schedule: CompanyPolicySchedule) => void;
  handleOpenDeleteScheduleModal?: (schedule: CompanyPolicySchedule) => void;
}

export default function CompanyPolicySchedulesTable ({ loading, hasCRUD, schedules, handleOpenDeleteScheduleModal, handleOpenEditScheduleModal } : Props) {

  const today = moment().startOf('day').toDate();
  const MAX_TABLE_COLUMNS = 6;

  const checkIfOngoingSchedule = (startDate: Date, endDate: Date) => {
    return today >= moment(startDate).startOf('day').toDate() && today <= moment(endDate).startOf('day').toDate();
  }

  return (
    <Table responsive bordered className="bg-white">
      <thead>
        <tr>
          <th>Policy</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Created By</th>
          <th>Status</th>
          {
            hasCRUD &&
            <th>Action</th>
          }
        </tr>
      </thead>
      <tbody>
        {
          loading ? 
          <tr>
            <td colSpan={MAX_TABLE_COLUMNS}>
              <Loading />
            </td>
          </tr>
          :
          schedules.length === 0 ? 
          <tr>
            <td colSpan={MAX_TABLE_COLUMNS} className="text-center">
              No Scheduled Polices Found
            </td>
          </tr>
          :
          schedules.map((item, index) => {
            const isOngoing = checkIfOngoingSchedule(new Date(item.start_date), new Date(item.end_date));
            return (
              <tr key={item._id} id={'ongoingSchedule' + index}>
                <td>
                  <div>
                    {item.policy_details.name}
                  </div>
                </td>
                <td >
                  {moment(new Date(item.start_date)).format(DateFormat)} 
                </td>
                <td>{moment(new Date(item.end_date)).format(DateFormat)}</td>
                <td>{item.created_by_user?.name}</td>
                <td>
                  {
                    isOngoing ?
                    <>
                      <Badge color="success" > <i className="fas fa-sync-alt fa-spin fa-lg" ></i> Ongoing</Badge>
                    </>
                    :
                    new Date(item.end_date) < today ?
                      <Badge color="info"> Lapsed</Badge>
                    :
                      <Badge color="primary" className="text-white"> Upcoming</Badge>
                  }
                </td>
                {
                  hasCRUD &&
                  <td>
                    <UncontrolledDropdown
                      size="sm"
                      onClick={e => {
                        e.stopPropagation();
                      }}
                    >
                      <DropdownToggle caret color="primary">
                        Actions
                      </DropdownToggle>
                      <DropdownMenu container="body">
                        <DropdownItem onClick={() => handleOpenEditScheduleModal(item)}>
                          <small>Update</small>
                        </DropdownItem>
                        <DropdownItem onClick={() => handleOpenDeleteScheduleModal(item)}>
                          <small>Delete</small>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </td>
                }
              </tr>
            )}
          )
        }
      </tbody>
    </Table>
  )
}

